import { Component, HostBinding, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nav-horizontal-item',
  templateUrl: './nav-horizontal-item.component.html',
  styleUrls: ['./nav-horizontal-item.component.scss'],
  standalone: true,
  imports:[
    RouterModule,
    MatIconModule,
    CommonModule
  ]
})
export class NkNavHorizontalItemComponent {
  @HostBinding('class') classes = 'nav-item';
  @Input() item: any;
}
